import { Button, Table, Tag } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import { useState } from 'react'
import {
  CuratedTemplateAvailability,
  CuratedTemplateSummary
} from '../../../domain/curatedTemplates/curatedTemplate'
import { useCuratedTemplatesPageQuery } from '../../../domain/curatedTemplates/curatedTemplatesQueries'
import VSpace from '../../common/VSpace'
import CuratedTemplateDrawer from './CuratedTemplateDrawer'
import { availabilityDisplay, formatLastUpdated } from './curatedTemplatesDisplayModel'
import IntercomSpacer from '../../IntercomSpacer'

const PAGE_SIZE = 20

type EditorState = {
  open: boolean
  curatedTemplateId: string | null
}

const closedEditor: EditorState = { open: false, curatedTemplateId: null }

const CuratedTemplatesSection = () => {
  const [page, setPage] = useState(1)
  const [editorState, setEditorState] = useState<EditorState>(closedEditor)
  const { data, isFetching } = useCuratedTemplatesPageQuery(page, PAGE_SIZE)

  const openEditor = (curatedTemplateId: string | null) => {
    setEditorState({ open: true, curatedTemplateId })
  }

  return <VSpace size="middle">
    <div>
      <Button type="primary" icon={<PlusOutlined />} onClick={() => openEditor(null)}>
        New Curated Template
      </Button>
    </div>
    <Table<CuratedTemplateSummary>
      dataSource={data?.templates ?? []}
      loading={isFetching}
      rowKey="curatedTemplateId"
      onRow={template => ({
        onClick: () => openEditor(template.curatedTemplateId),
        style: { cursor: 'pointer' }
      })}
      columns={[
        {
          title: 'Name',
          dataIndex: 'name'
        },
        {
          title: 'Availability',
          dataIndex: 'availability',
          width: 140,
          render: (availability: CuratedTemplateAvailability) => {
            const { label, color } = availabilityDisplay(availability)
            return <Tag color={color}>{label}</Tag>
          }
        },
        {
          title: 'Last Updated',
          dataIndex: 'lastUpdatedAt',
          width: 220,
          render: (lastUpdatedAt: string) => formatLastUpdated(lastUpdatedAt)
        },
        {
          title: 'Actions',
          key: 'actions',
          align: 'right',
          width: 100,
          render: (_, template) => <Button type="link" size="small" onClick={() => openEditor(template.curatedTemplateId)}>
            Edit
          </Button>
        }
      ]}
      pagination={{
        current: page,
        pageSize: PAGE_SIZE,
        total: data?.totalCount ?? 0,
        showSizeChanger: false,
        hideOnSinglePage: true,
        onChange: setPage
      }}
    />
    <CuratedTemplateDrawer
      open={editorState.open}
      curatedTemplateId={editorState.curatedTemplateId}
      onClose={() => setEditorState(prev => ({ ...prev, open: false }))}
      onClosed={() => setEditorState(closedEditor)}
    />
    <IntercomSpacer />
  </VSpace>
}

export default CuratedTemplatesSection
